// src/features/executive/account/AccountTab.tsx
import { useTranslation } from 'react-i18next'
import SectionHeader from 'features/executive/components/SectionHeader/SectionHeader'
import BalanceCard from './widgets/BalanceCard'
import AdvanceCard from './widgets/AdvanceCard'
import WalletCard from './widgets/WalletCard'
import FinancialSummaryCard from './widgets/FinancialSummaryCard'
import ExpenseCategoryCard from './widgets/ExpenseCategoryCard'
import TreatmentRevenueCard from './widgets/TreatmentRevenueCard'
import { CategoryRow, HeroRow, Section, TabRoot } from './usedStyle'

export default function AccountTab() {
  const { t } = useTranslation()
  return (
    <TabRoot>
      {/* Section 1: Position — balances, advances, wallets */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.ACCOUNT.SECTION.POSITION')}
          caption={t('EXECUTIVE.ACCOUNT.SECTION.POSITION_CAPTION')}
        />
        <HeroRow>
          <BalanceCard />
          <AdvanceCard />
          {/* <WalletCard /> */}
        </HeroRow>
      </Section>

      {/* Section 2: Income vs Expense — financial summary trend */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.ACCOUNT.SECTION.FLOW')}
          caption={t('EXECUTIVE.ACCOUNT.SECTION.FLOW_CAPTION')}
        />
        <FinancialSummaryCard />
      </Section>

      {/* Section 3: Composition — revenue & expense by category */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.ACCOUNT.SECTION.COMPOSITION')}
          caption={t('EXECUTIVE.ACCOUNT.SECTION.COMPOSITION_CAPTION')}
        />
        <CategoryRow>
          <TreatmentRevenueCard />
          <ExpenseCategoryCard />
        </CategoryRow>
      </Section>
    </TabRoot>
  )
}
